import { PeopleDirectoryPage } from "@/components/people/people-directory-page";

/** User-owned mutable lead copies. */
export function LeadsPage() {
  return <PeopleDirectoryPage scope="lead" />;
}
